import React from 'react'
import Classes from '../Dashboard.module.css'
import { useNavigate } from 'react-router-dom'

export default function Hero3() {

    const navigateTo = useNavigate();

    return (
        <>
            <div className={Classes.hero3} >
                <div className={Classes.box} >
                    <h5>View reports</h5>
                    <p>Access detailed reports of your personal data found across the internet.</p>
                    <button type='button' onClick={() => { navigateTo('/reports') }} > <h5>View reports</h5> </button>
                </div>
                <div className={Classes.box} >
                    <h5>Manage billing</h5>
                    <p>Manage your saved payment methods and pick a default payment method for subscriptions.</p>
                    <button type='button' onClick={() => { window.open('https://billing.stripe.com/')}}> <h5>Manage billing</h5> </button>
                </div>
                <div className={Classes.box} >
                    <h5>Get support</h5>
                    <p>Send us a message and we’ll get back to you on the same business day.</p>
                    <button type='button' onClick={() => { navigateTo('/contact-us') }} > <h5>Contact support</h5> </button>
                </div>
            </div>
        </>
    )
}
